import { Modal } from "antd";
import React from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { ContentLoader, FormField, FormFieldType } from "@components";
import {
  ApplicationsActions,
  selectRejectUploadedAgreementLoading,
  selectCurrentApplicationId
} from "@redux";
import { required, trb, i18 } from "@utilities";

export const RejectUploadAgreement = ({ onClose }) => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const isLoading = useSelector(selectRejectUploadedAgreementLoading);

  const handleRejectUploadAgreement = async values => {
    await dispatch(ApplicationsActions.rejectUploadedAgreement(appId, values.comment));
    onClose();
  };

  return (
    <Form
      onSubmit={handleRejectUploadAgreement}
      render={({ handleSubmit }) => {
        return (
          <Modal
            visible
            onOk={handleSubmit}
            onCancel={onClose}
            okText={trb(i18.Buttons.Ok)}
            cancelText={trb(i18.Buttons.Cancel)}
          >
            <form id="rejectDocument" className="my-4" onSubmit={handleSubmit}>
              {isLoading ? (
                <ContentLoader />
              ) : (
                <FormField
                  name="comment"
                  component={FormFieldType.input}
                  title="Comment"
                  validate={required}
                  size="large"
                />
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
